export default {
  API_URL: "https://multimagazyn-net-test-win.azurewebsites.net/api",
};
